export function isClientLimitModel(clientLimit) {
  // Only tenants with a positive limit are on the client limit model.
  // -1 means unlimited clients; 0/null/undefined mean no limit was set.
  return clientLimit > 0;
}

export function isFreeClientLimitModelTier(clientLimit) {
  return isClientLimitModel(clientLimit) && !window.tenant.is_active;
}

export function isPaidClientLimitModelTier(clientLimit) {
  return isClientLimitModel(clientLimit) && window.tenant.is_active;
}
